import createStore from 'unistore'

export const store = createStore({ logged: false, token:'' })


